export default function ThemeTag({ light = false }) {
  return (
    <p className={`theme-tag ${light ? "theme-tag-light" : ""}`} data-testid="event-theme-tag">
      Theme · “Strategies for Impact and Innovation”
    </p>
  );
}
